import { createIcon } from '@chakra-ui/react';

export const Mail = createIcon({
  displayName: 'Mail',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M11.334 13.6667H4.66732C2.66732 13.6667 1.33398 12.6667 1.33398 10.3333V5.66668C1.33398 3.33334 2.66732 2.33334 4.66732 2.33334H11.334C13.334 2.33334 14.6673 3.33334 14.6673 5.66668V10.3333C14.6673 12.6667 13.334 13.6667 11.334 13.6667Z" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.3327 6L9.24601 7.66667C8.55935 8.21333 7.43268 8.21333 6.74601 7.66667L4.66602 6" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </>
  ),
});
